import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingMenu from '../../components/feature/FloatingMenu';
import ManifestoVideoSection from './components/ManifestoVideoSection';
import ThreeStepsSection from './components/ThreeStepsSection';
import ThisWeekUpdatesSection from './components/ThisWeekUpdatesSection';
import OngoingChallengesSection from './components/OngoingChallengesSection';
import PeopleCommunitySection from './components/PeopleCommunitySection';
import NotForEveryoneSection from './components/NotForEveryoneSection';
import FAQSection from './components/FAQSection';
import FinalCTASection from './components/FinalCTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <FloatingMenu />
      
      {/* ファーストビュー: 吉野、気になる。でも何から? */}
      <ManifestoVideoSection />
      
      {/* はじめての方へ: 迷子にならない3ステップ */}
      <div id="three-steps">
        <ThreeStepsSection />
      </div>
      
      {/* Instagram/note/イベント（縦3段構成） */}
      <div id="this-week">
        <ThisWeekUpdatesSection />
      </div>
      
      {/* 人が見えるコミュニティ */}
      <div id="people">
        <PeopleCommunitySection />
      </div>
      
      {/* いま動いている挑戦 */}
      <OngoingChallengesSection />
      
      {/* 正直、こんな人には向いていません */}
      <NotForEveryoneSection />
      
      {/* よくある『不安』に答えます */}
      <FAQSection />
      
      {/* 最終CTA: 吉野なんでも相談所へ */}
      <FinalCTASection />
      
      <Footer />
    </div>
  );
};

export default HomePage;
